import styled from 'styled-components';

const MentorImage = styled.img`
  width: 100px;
  height: 90px;
  border-radius: 50vw;

  @media only screen and (max-width: 768px) {
    width: 45px;
    height: 45px;
  }

`;

export default MentorImage;
